import React from "react";

const ProductNote = (props) => {
    let strLength = props.content.length;
    let word = props.content;
    if (strLength > 0) {
        let counter = strLength / 20;
        let content = [];

        if (counter > 1) {
            for (let i = 0; i < counter; i++) {
                let slice = word.substring(0, 20);
                word = word.slice(20);
                // console.log(word);
                content.push(slice);
            }
        } else {
            content = [props.content];
        }

        return (
            <>
                <div className='flex flex-1 flex-col pl-6 text-sm text-gray-300'>
                    {content.map((item, index) => {
                        return (
                            <p className='d-block' key={index}>
                                {item}
                            </p>
                        );
                    })}
                </div>
            </>
        );
    } else {
        return;
    }
};

export default ProductNote;
